import layout from "./en/layout.json";
import generalMessage from "./en/generalMessage.json";
import component from "./en/component.json";
import options from "./en/options.json";
import common from "./en/common.json";

import login from "./en/page/login.json";
import forgetPassword from "./en/page/forgetPassword.json";
import changePassword from "./en/page/changePassword.json";
import otp from "./en/page/otp.json";
import tokenExpired from "./en/page/tokenExpired.json";
import welcome from "./en/page/welcome.json";

import onlineMerchantDetail from "./en/page/merchantManagement/onlineMerchantDetail.json";
import addOnlineMerchant from "./en/page/merchantManagement/addOnlineMerchant.json";
import onlineEmployeeDetail from "./en/page/merchantManagement/onlineEmployeeDetail.json";
import addOnlineEmployee from "./en/page/merchantManagement/addOnlineEmployee.json";

import transactionSummary from "./en/page/finance/transactionSummary.json";
import refundList from "./en/page/finance/refundList.json";
import debit from "./en/page/finance/debit.json";
import settlementPlan from "./en/page/finance/settlementPlan.json";
import reconciliation from "./en/page/finance/reconciliation.json";
import bankFile from "./en/page/finance/bankfile.json";
import merchantMdr from "./en/page/finance/merchantMdr.json";
import paymentGatewayCost from "./en/page/finance/paymentGatewayCost.json";
import fxRate from "./en/page/finance/fxRate.json";

import salesPerformance from "./en/page/analytics/salesPerformance.json";
import salesAchievement from "./en/page/analytics/salesAchievement.json";
import referrerPerformance from "./en/page/analytics/referrerPerformance.json";
import referrerTransactionVolume from "./en/page/analytics/referrerTransactionVolume.json";
import lowActivityMerchant from "./en/page/analytics/lowActivityMerchant.json";
import transactionActivity from "./en/page/analytics/transactionActivity.json";
import merchantDetail from "./en/page/analytics/merchantDetail.json";
import dataDashboard from "./en/page/analytics/dataDashboard.json";

import transactions from "./en/page/transactions.json";
import agents from "./en/page/agents.json";
import payfacs from "./en/page/payfacs.json";
import merchants from "./en/page/merchants.json";
import employees from "./en/page/employees.json";
import dialogs from "./en/page/dialogs.json";
import rolePermissions from "./en/page/rolePermissions.json";
import compliance from "./en/page/compliance.json";

import paperRoll from "./en/page/paperRoll.json";
import abnormalPayment from "./en/page/internalReports/abnormalPayment.json";
import internalReports from "./en/page/internalReports/internalReports.json";

import statisticsOfflineMerchant from "./en/page/systemStatistics/statisticsOfflineMerchant.json";
import statisticsOfflineTransaction from "./en/page/systemStatistics/statisticsOfflineTransaction.json";
import statisticsOnlineMerchant from "./en/page/systemStatistics/statisticsOnlineMerchant.json";
import statisticsOnlineTransaction from "./en/page/systemStatistics/statisticsOnlineTransaction.json";
import statisticsSalesperson from "./en/page/systemStatistics/statisticsSalesperson.json";

import statement from "./en/page/statement.json";

import onlineMerchantManagement from "./en/form/onlineMerchantManagement.json";

export default {
  layout: layout,
  "general.message": generalMessage,
  component: component,
  page: {
    login: login,
    forgetPassword: forgetPassword,
    changePassword: changePassword,
    otp: otp,
    tokenExpired: tokenExpired,
    welcome: welcome,
    merchantManagement: {
      onlineMerchantDetail: onlineMerchantDetail,
      addOnlineMerchant: addOnlineMerchant,
      onlineEmployeeDetail: onlineEmployeeDetail,
      addOnlineEmployee: addOnlineEmployee,
    },
    finance: {
      "transaction.summary": transactionSummary,
      "refund.list": refundList,
      debit: debit,
      "settlement.plan": settlementPlan,
      bankfile: reconciliation,
      bankSubmission: bankFile,
      "merchant.mdr": merchantMdr,
      "payment.gateway.cost": paymentGatewayCost,
      fxRate: fxRate,
    },
    analytics: {
      "sales.performance": salesPerformance,
      "sales.achievement": salesAchievement,
      "referrer.performance": referrerPerformance,
      "referrer.transaction.volume": referrerTransactionVolume,
      "low.activity.merchant": lowActivityMerchant,
      "transaction.activity": transactionActivity,
      "merchant.detail": merchantDetail,
      systemStatistics: {
        offlineMerchant: statisticsOfflineMerchant,
        offlineTransaction: statisticsOfflineTransaction,
        onlineMerchant: statisticsOnlineMerchant,
        onlineTransaction: statisticsOnlineTransaction,
        salesperson: statisticsSalesperson,
      },
      dataDashboard,
    },
    transactions: transactions,
    agents: agents,
    payfacs: payfacs,
    merchants: merchants,
    employees: employees,
    dialogs: dialogs,
    rolePermissions: rolePermissions,
    compliance: compliance,
    paperRoll: paperRoll,
    statement: statement,
    internalReports: {
      internalReports: internalReports,
      abnormality: {
        payment: abnormalPayment,
      },
    },
  },
  form: {
    onlineMerchantManagement,
  },
  options: options,
  common: common,
};
